import { MAX_TITLE_LENGTH, MIN_TITLE_LENGTH } from "@gen2/app/invites/send-invites/requests/schema";

export const validateGroupName = (name: string) => {
    if (!name.trim()) {
        return 'Group name is required';
    }
    if (name.length < MIN_TITLE_LENGTH) {
        return `Group name must be at least ${MIN_TITLE_LENGTH} characters`;
    }
    if (name.length >= MAX_TITLE_LENGTH - 1) {
        return `Group name must not be greater than ${MAX_TITLE_LENGTH - 1} characters`;
    }
    return '';
};